<div class="container-fluid dashboard-container">
  <div class="row m-0 mt-1 mb-1 d-flex justify-content-center align-items-center ">
    <!-- Configuration Card -->
    <div class="col-md-4 mb-4" *ngIf="ConfigurationAllow">
      <div class="dashboard-card config-card" (click)="OnConfigClick()">
        <div class="card-content">
          <div class="card-icon">
            <img src="../../assets/images/Configuration_img3.png" alt="Configuration">
          </div>
          <div class="card-text">
            <h3 class="card-title">Configuration</h3>
            <p class="card-description">Configuration Management</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Quick Loan Card -->
    <div class="col-md-4 mb-4" *ngIf="QUICKLOANAllow">
      <div class="dashboard-card loan-card" (click)="OnQuickLoanClick()">
        <div class="card-content">
          <div class="card-icon">
            <img src="../../assets/images/LOS_IMG3.png" alt="Quick Loan">
          </div>
          <div class="card-text">
            <h3 class="card-title">LOS</h3>
            <p class="card-description">Loan Originating System</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- LMS Card -->
    <div class="col-md-4 mb-4" *ngIf="LMSAllow">
      <div class="dashboard-card lms-card" (click)="OnLMSClick()">
        <div class="card-content">
          <div class="card-icon">
            <img src="../../assets/images/LMS_IMG3.png" alt="LMS">
          </div>
          <div class="card-text">
            <h3 class="card-title">LMS</h3>
            <p class="card-description">Loan Management System</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Accounting Card -->
    <div class="col-md-4 mb-4" *ngIf="ACCOUNTINGAllow">
      <div class="dashboard-card accounting-card" (click)="OnAccountingClick()">
        <div class="card-content">
          <div class="card-icon">
            <img src="../../assets/images/Accounting.jpg" alt="Accounting">
          </div>
          <div class="card-text">
            <h3 class="card-title">Accounting</h3>
            <p class="card-description">Intigrated GL Accounting</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Reports Card -->
    <div class="col-md-4 mb-4" *ngIf="REPORTAllow">
      <div class="dashboard-card reports-card" (click)="OnReportsClick()">
        <div class="card-content">
          <div class="card-icon">
            <img src="../../assets/images/Report.jpg" alt="Reports">
          </div>
          <div class="card-text">
            <h3 class="card-title">Reports</h3>
            <p class="card-description">Management Reports</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Managed Portfolio Card -->
    <div class="col-md-4 mb-4" *ngIf="PORTFOLIOAllow">
      <div class="dashboard-card portfolio-card" (click)="OnpPartnerClick()">
        <div class="card-content">
          <div class="card-icon">
            <img src="../../assets/images/portfolio3.png" alt="Portfolio">
          </div>
          <div class="card-text">
            <h3 class="card-title">Managed Portfolio</h3>
            <p class="card-description">Landing Partner Fund Portfolio</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Deposits Card -->
    <div class="col-md-4 mb-4" *ngIf="DEPOSITAllow">
      <div class="dashboard-card deposit-card" (click)="OnDepositClick()">
        <div class="card-content">
          <div class="card-icon">
            <img src="../../assets/images/Deposit.png" alt="Deposit">
          </div>
          <div class="card-text">
            <h3 class="card-title">Deposits</h3>
            <p class="card-description">Public Deposits</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
